export default class ProviderInfo {
    providerKey = null
    providerId = null
    name = null
    financingName = null
    abbreviatedName = null
    fundingSourceDescription = null
    fundingSourceDescriptionByProductType = null
    /**
     * @type {string | null}
     */
    logo = null
    footerLogo = null
    paymentCalculatorButtonsHidden = false
    paymentCalculatorRecalculatingModal = false
    autoShowLearnHowDrawer = false
    fetchPaymentPlansOnPreAuth = true
    fetchPaymentPlansOnResume = false
    fetchPaymentPlansOnFullResume = false
    maxDownPaymentCents = null
    minPaymentCalculatorCents = null
    showPaymentPlanDetails = false
    completeAfterEsign = false
    preauthExpireDays = null
    subLenders = null
    supportsFullAppMode = false
    showDownPaymentAcknowledgeByProviderRoles = []
    showBankCardErrorModal = false
    selectPaymentPlanOnReviewScreen = false
    creditType = null
    paymentPlanFilterOverrides = null
    /**
     * @type {boolean | false}
     */
    canFinishWithExistingAccount = false
    /**
     * @type {string | null}
     */
    providerProductType = null
    /**
     * @type {object | null}
     */
    altProduct = null

    constructor({
        providerId = null,
        name = null,
        financingName = null,
        abbreviatedName = null,
        fundingSourceDescription = null,
        fundingSourceDescriptionByProductType = null,
        logo = null,
        footerLogo = null,
        paymentCalculatorButtonsHidden = false,
        paymentCalculatorRecalculatingModal = false,
        autoShowLearnHowDrawer = false,
        fetchPaymentPlansOnPreAuth = true,
        fetchPaymentPlansOnResume = false,
        fetchPaymentPlansOnFullResume = false,
        maxDownPaymentCents = 0,
        minPaymentCalculatorCents = 0,
        showPaymentPlanDetails = false,
        completeAfterEsign = false,
        preauthExpireDays = 30,
        subLenders = null,
        supportsFullAppMode = false,
        showDownPaymentAcknowledgeByProviderRoles = [],
        showBankCardErrorModal = false,
        selectPaymentPlanOnReviewScreen = false,
        creditType = null,
        paymentPlanFilterOverrides = null,
        canFinishWithExistingAccount = false,
        providerProductType = null,
        altProduct = null,
    }) {
        this.providerId = providerId
        this.name = name
        this.financingName = financingName
        this.abbreviatedName = abbreviatedName
        this.fundingSourceDescription = fundingSourceDescription
        this.fundingSourceDescriptionByProductType = fundingSourceDescriptionByProductType
        this.footerLogo = footerLogo
        this.logo = logo
        this.paymentCalculatorButtonsHidden = paymentCalculatorButtonsHidden
        this.paymentCalculatorRecalculatingModal = paymentCalculatorRecalculatingModal
        this.autoShowLearnHowDrawer = autoShowLearnHowDrawer
        this.fetchPaymentPlansOnPreAuth = fetchPaymentPlansOnPreAuth
        this.fetchPaymentPlansOnResume = fetchPaymentPlansOnResume
        this.fetchPaymentPlansOnFullResume = fetchPaymentPlansOnFullResume
        this.maxDownPaymentCents = maxDownPaymentCents
        this.minPaymentCalculatorCents = minPaymentCalculatorCents
        this.showPaymentPlanDetails = showPaymentPlanDetails
        this.completeAfterEsign = completeAfterEsign
        this.preauthExpireDays = preauthExpireDays
        this.subLenders = subLenders
        this.supportsFullAppMode = supportsFullAppMode
        this.showDownPaymentAcknowledgeByProviderRoles = showDownPaymentAcknowledgeByProviderRoles
        this.showBankCardErrorModal = showBankCardErrorModal
        this.selectPaymentPlanOnReviewScreen = selectPaymentPlanOnReviewScreen
        this.creditType = creditType
        this.paymentPlanFilterOverrides = paymentPlanFilterOverrides
        this.canFinishWithExistingAccount = canFinishWithExistingAccount
        this.providerProductType = providerProductType
        this.altProduct = altProduct
    }
}
